import { render, staticRenderFns } from "./FormRule.vue?vue&type=template&id=6ac98de9&scoped=true&"
import script from "./FormRule.vue?vue&type=script&lang=js&"
export * from "./FormRule.vue?vue&type=script&lang=js&"
import style0 from "./FormRule.vue?vue&type=style&index=0&id=6ac98de9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac98de9",
  null
  
)

export default component.exports